import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

// While Best Of takes over the homepage, / shows the current edition too.
const BEST_OF_EDITION_PATH = /^\/(best-of\/\d{4}\/?)?$/;

const withoutResource = (search: string) => {
  const params = new URLSearchParams(search);
  params.delete('resource');
  return params.toString();
};

export default function useRouteScrollReset() {
  const location = useLocation();
  const previous = useRef<{ pathname: string; search: string } | null>(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const prior = previous.current;
    const sameEdition =
      prior !== null &&
      prior.pathname === location.pathname &&
      BEST_OF_EDITION_PATH.test(location.pathname);
    // Opening or closing a resource modal only adds or removes ?resource=.
    const onlyResourceModalChanged =
      sameEdition && withoutResource(prior.search) === withoutResource(location.search);
    const staysInBestOfWorkspace =
      sameEdition &&
      (onlyResourceModalChanged ||
        params.has('category') ||
        params.has('submission') ||
        ['mine', 'my-votes'].includes(params.get('view') || ''));
    previous.current = { pathname: location.pathname, search: location.search };

    // Category/modal changes within an edition are in-page navigation.
    if (!staysInBestOfWorkspace) window.scrollTo(0, 0);
  }, [location]);
}
